<template>
  <div class="faq-detail">
    <a-breadcrumb class="breadcrumb">
      <a-breadcrumb-item
        ><a
          href="javascript:void(0)"
          @click="goHome"
          :class="[
            'breadcrump-clickable',
            isILocalizeFn() ? 'breadcrump-clickable-KNOWLEDGE' : '',
          ]"
          >{{ displayName }}</a
        ></a-breadcrumb-item
      >
      <a-breadcrumb-item
        ><a
          href="javascript:void(0)"
          @click="goFaqList"
          :class="[
            'breadcrump-clickable',
            isILocalizeFn() ? 'breadcrump-clickable-KNOWLEDGE' : '',
          ]"
          >{{ sectionName }}</a
        ></a-breadcrumb-item
      >
      <a-breadcrumb-item>{{ question }}</a-breadcrumb-item>
    </a-breadcrumb>
    <div class="content">
      <h2>{{ question }}</h2>
      <viewer :images="imgs">
        <span v-html="answer" :class="'con-wrap'"></span>
      </viewer>
    </div>
  </div>
</template>
<script>
import { loadFaqDetail } from "@/api/index";
import resultMixin from "./component/resultMixin.js";
import { dealShowPath } from "@/utils/path";
import Vue from "vue";
import VueLazyload from "vue-lazyload";
import "viewerjs/dist/viewer.css";
import Viewer from "v-viewer";
import store from '@/vuex/index'
Vue.use(Viewer);
Vue.use(VueLazyload);
export default {
  name: "faqDetail",
  mixins: [resultMixin],
  inject: ["isILocalizeFn"],
  data() {
    return {
      paths: [],
      question: "",
      answer: "",
      sectionName: "",
      imgs: [],
      displayName: "",
    };
  },
  props: {
    loadings: Object,
  },
  mounted() {
    this.init();
    // this.$bus.$on("seeDetail", this.init);
    this.$bus.pageInfo.isFirst = false;
  },
  beforeRouteUpdate(to, form, next) {
    this.init(to.params);
    next();
  },
  methods: {
    init(to) {
      this.$bus.$emit("loading", this.loadings);
      let {
        gameName,
        page,
        alias,
        gameIdKey: key,
        sectionIdKey,
        kmContentIdKey,
      } = to || this.$route.params;
      let platform = this.$bus.pageInfo.platform;
      let gameIdKey = this.$bus.pageInfo.gameIdKey || key;
      loadFaqDetail(gameIdKey, sectionIdKey, kmContentIdKey, alias, platform)
        .then((res) => {
          this.initFilter(res, gameIdKey, alias);
          this.displayName = res.displayName;
          let firstSectionList = res.sectionList[0];
          let item = firstSectionList["contentList"][0];
          this.sectionName = firstSectionList.sectionName;
          let { question, answer } = item;
          this.question = question;
          this.answer = answer;
          // this.answer = this.replaceImg(answer);
          store.commit("CHANGEISSHOWH5", res.isShowH5);
          store.commit("CHANGEAPPID", res.appId);
          store.commit("CHANGEAPPNAME", res.displayName);
          store.commit("CHANGEACCOUNTID", res.accountId);
        })
        .catch((err) => {});
    },
    replaceImg(answer) {
      let reg = /<img.*?\bsrc="(http[^"]+\.(png|jpg|bmp|gif|jpeg|tiff)).*?>/gi;
      return answer.replace(reg, (match, p1) => {
        // 收集图片，用于放大
        this.imgs.push(p1);
        return match
          .replace("src=", "data-src=")
          .replace("_src=", "data-loading=")
          .replace("/uploadThumb/", "/upload/")
          .replace(/title="[^"]*"/, "");
      });
    },
    seeSearchDetailItem() {
      this.init();
    },
    goHome() {
      let gameName = this.getGameName();
      let { page, alias, gameIdKey: key } = this.$route.params;
      let gameIdKey = this.$bus.pageInfo.gameIdKey || key;
      let path = `/${gameName}/${page}/${alias}/${gameIdKey}`;
      this.$router.push({ path });
    },
    goFaqList() {
      let gameName = this.getGameName();
      let { page, alias, sectionIdKey, gameIdKey: key } = this.$route.params;
      let gameIdKey = this.$bus.pageInfo.gameIdKey || key;
      let path = `/${gameName}/${page}/${alias}/${gameIdKey}/${sectionIdKey}`;
      this.$router.push({ path });
    },
    getGameName() {
      let gameName = this.$route.params.gameName;
      return dealShowPath(gameName);
    },
  },
  beforeDestroy() {
    this.$bus.$off("seeDetail");
  },
};
</script>
<style lang="scss" scoped>
.faq-detail {
  margin-top: 20px;
  .breadcrumb {
    margin-bottom: 20px;
  }
  .breadcrump-clickable {
    color: #409eff;
  }
  .breadcrump-clickable-KNOWLEDGE,
  .breadcrump-clickable-KNOWLEDGE:hover {
    color: #00bbbb;
  }
  .content {
    .con-wrap {
      display: flex;
      flex-direction: column;
      align-items: flex-start;
      justify-content: flex-start;
      max-width: 1200px;
      /deep/ ol,
      /deep/ ul,
      /deep/ li {
        all: revert;
      }
    }
  }
}
</style>
